import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useEditController, useNotify, useTranslate } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { ShowCard } from 'src/components/uiElements/cards/ShowCard'
import { LoadingButton } from '@mui/lab'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import DownloadIcon from '@mui/icons-material/Download';
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { timeZoneFormat } from 'src/components/pages/sales/reservation/helper/argToTimezoneFormat'
import { CATEGORY_OPTIONS } from './categoryOptions'

export const ConditionsTab = ({id}) => {
    const translate = useTranslate()
    const notify = useNotify()
    const user = JSON.parse(localStorage.getItem('user') ?? '{}')
    const { record, isFetching } = useEditController({ resource: 'business-unit', id })
    const [showConfirmCategory, setShowConfirmCategory] = useState(false)
    const [newCategory, setNewCategory] = useState()
    const [originalCategory, setOriginalCategory] = useState()
    const [loadingUpdate, setLoadingUpdate] = useState(false)
    const [conditionsData, setConditionsData] = useState([])
    const [filesData, setFilesData] = useState([])
    const [linksData, setLinksData] = useState([])
    const [isFetchingData, setIsFetchingData] = useState(false)
    const [openCreateModal, setOpenCreateModal] = useState(false)
    const [message, setMessage] = useState('')
    const [isLoadingCreate, setIsLoadingCreate] = useState(false)
    const [type, setType] = useState(1)
    const [idToEdit, setIdToEdit] = useState(null)
    const [idToDelete, setIdToDelete] = useState(null)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [confirmDelete, setConfirmDelete] = useState(false)
    const [loadingDelete, setLoadingDelete] = useState(false)
    const [openFileModal, setOpenFileModal] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)

    useEffect(()=>{
        setOriginalCategory(record?.category)
    },[record])

    useEffect(()=>{
        if(confirmDelete){
            onDeleteCondition()
        }
        
    },[confirmDelete])

    useEffect(()=>{
        if(idToEdit){
            setOpenCreateModal(true)
        }
    },[idToEdit])

    const handleChangeCategory = (value) =>{
        const newValue = value.target?.value
        setNewCategory(newValue)
        if(newValue !== originalCategory){
            setShowConfirmCategory(true)
        } else {
            setShowConfirmCategory(false)
        }
    }

    const onCancelCategory = () =>{
        const newValue = {target:{value:originalCategory}}
        handleChangeCategory(newValue)
    }

    const onConfirmCategoryUpdate = () =>{
        setLoadingUpdate(true)
        businessUnitServices.updateCategory(record.id, newCategory).then(()=>{
            setOriginalCategory(newCategory)
            setShowConfirmCategory(false)
        }).finally(()=>{
            setLoadingUpdate(false)
        })
    }

    const getExtraData = async() =>{
        setIsFetchingData(true)
        await businessUnitServices.getExtraBusinessUnit(record.id).then(res=>{
            let auxLinks = []
            let auxFiles = []
            let auxConditions = []
            for(let item of res){
                if(item.type === 1){
                    auxConditions.push(item)
                } else if(item.type === 2){
                    auxFiles.push(item)
                } else if(item.type === 3){
                    auxLinks.push(item)
                }

            }
            setConditionsData(auxConditions)
            setFilesData(auxFiles)
            setLinksData(auxLinks)
        }).finally(()=>{
            setIsFetchingData(false)
        })
    }

    useEffect(()=>{
        getExtraData()
    },[])

    const createCondition = async () =>{
        setIsLoadingCreate(true)
        await businessUnitServices.createCondition({
            description:message,
            business_unit_id:record.id,
            type:type,
            user_id:user.user_id
        }).then(()=>{
            setOpenCreateModal(false)
            setMessage('')
            if(type === 1){
                notify('ra.notification.created_success_femenine', {type:'success', messageArgs:{element:translate('ra.field.condition')}})
            } else if(type === 2){
                notify('ra.notification.created_success_masculine', {type:'success', messageArgs:{element:translate('ra.field.file')}})
            } else {
                notify('ra.notification.created_success_masculine', {type:'success', messageArgs:{element:'link'}})
            }
            getExtraData()
        }).catch(()=>{
            if(type === 1){
                notify('ra.notification.created_error_femenine', {type:'error', messageArgs:{element:translate('ra.field.condition')}})
            } else if(type === 2){
                notify('ra.notification.created_error_masculine', {type:'error', messageArgs:{element:translate('ra.field.file')}})
            } else {
                notify('ra.notification.created_error_masculine', {type:'error', messageArgs:{element:'link'}})
            }
            
        }).finally(()=>{
            setIsLoadingCreate(false)
        })
    }

    const updateCondition = async () =>{
        setIsLoadingCreate(true)
        await businessUnitServices.updateCondition(idToEdit, message).then(()=>{
            setIdToEdit(null)
            setOpenCreateModal(false)
            getExtraData()
            setMessage('')
            notify('ra.notification.updated_success_femenine', {type:'success', messageArgs:{element:translate('ra.field.condition')}})
            setSelectedFile(null)
        }).catch(()=>{
            notify('ra.notification.updated_error_femenine', {type:'error', messageArgs:{element:translate('ra.field.condition')}})
        }).finally(()=>{
            setIsLoadingCreate(false)
        })
    }

    const saveFile = (file, name) =>{
        const a = document.createElement('a');
        a.href = file;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    const onCloseModal = () =>{
        setOpenCreateModal(false) 
        setMessage('')
        setIdToEdit(null)
    }

    const handleFileChange = (event) => {
        if(event.target.files[0]){
            const file = event.target.files[0];
            const url = URL.createObjectURL(file);
            const newFile = {file, blob:url}
            setSelectedFile(newFile);
        }
    };

    const onDeleteCondition = async () =>{
        setLoadingDelete(true)
        await businessUnitServices.deleteCondition(idToDelete).then(()=>{
            notify('ra.notification.delete_condition_success', {type:'success'})
            setOpenDeleteModal(false)
            getExtraData()
            setConfirmDelete(false)
        }).catch(()=>{
            notify('ra.notification.delete_condition_error', {type:'error'})
        }).finally(()=>{
            setLoadingDelete(false)
        })
    }

    const uploadFile = async () =>{
        const formData = new FormData();
        formData.append('file_url', selectedFile.file);
        formData.append('business_unit_id', record.id);
        formData.append('user_id', user.user_id);
        setIsLoadingCreate(true)
        await businessUnitServices.uploadFileCondition(formData).then(()=>{
            setOpenFileModal(false)
            getExtraData()
            notify('ra.notification.created_success_masculine', {type:'success', messageArgs:{element:translate('ra.field.file')}})
        }).catch(()=>{
            notify('ra.notification.created_error_masculine', {type:'error', messageArgs:{element:translate('ra.field.file')}})
        }).finally(()=>{
            setIsLoadingCreate(false)
        })
    }

    const onCloseFile = ()=>{
        setSelectedFile(null);
        setOpenFileModal(false)
    }

  return (
    <>
        <Grid container>
            <EditInputsWrap label={translate('ra.field.category')} required>
                {isFetching ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                <SelectInput
                    size='small'
                    optionsText={['name']}
                    disabled={!hasPermissionFunction('business-unit-extra', 'edit')}
                    fullWidth
                    label=''
                    source='category'
                    value={newCategory === undefined ? originalCategory : newCategory}
                    onChange={handleChangeCategory}
                    options={CATEGORY_OPTIONS}
                />
                )}
            </EditInputsWrap>
            {showConfirmCategory && (loadingUpdate ? 
            <EditInputsWrap >
                <CircularProgress/>
            </EditInputsWrap>
            :
            <EditInputsWrap >
                <DoneIcon onClick = {onConfirmCategoryUpdate} style={{cursor:'pointer'}} color='success'/>
                <CloseIcon onClick={onCancelCategory} style={{cursor:'pointer'}} color='error'/>
            </EditInputsWrap>)}
        </Grid>
        <ShowCard
            cardStyle={{width:'100%'}}
            title={translate('ra.field.commercial_terms')}
            actionButtonJustify='flex-end'
            actionButtonText={translate('ra.action.add')}
            actionButtonStyle={{ width: 'fit-content' }}
            actionButtonDisabled={!hasPermissionFunction('business-unit-extra', 'edit')}
            onClickButton={()=>{
                setOpenCreateModal(true)
                setType(1)
            }}
            
        >
            <TableContainer component={Paper} sx={{ marginY: '30px' }}>
                <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                <TableHead>
                    <TableRow>
                        <TableCell >{translate('ra.field.message')}</TableCell>
                        <TableCell align='left'>{translate('ra.field.created_at')}</TableCell>
                        <TableCell align='left'>{translate('ra.field.updated_at')}</TableCell>
                        <TableCell align='left'>{translate('ra.auth.username')}</TableCell>
                        <TableCell align='left'></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        isFetchingData?
                        [...Array(3)].map((_, i) => (
                            <TableRow key={i}>
                                {[...Array(4)].map((_, i) => (<TableCell >
                                    <Skeleton variant='rectangular' width={'100%'} height={20} />
                                </TableCell>))}
                            </TableRow>
                        ))

                        :
                        conditionsData.map((condition, key)=>(
                            <TableRow key={key}>
                                <TableCell >{condition.description}</TableCell>
                                <TableCell align='left'>
                                    {timeZoneFormat(condition.created_at, '00:00')}
                                </TableCell>
                                <TableCell align='left'>
                                    {timeZoneFormat(condition.updated_at, '00:00')}
                                </TableCell>
                                <TableCell align='left'>{condition.user}</TableCell>
                                <TableCell align='left'>
                                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                                        <EditIcon 
                                            onClick={()=>{
                                                if(hasPermissionFunction('business-unit-extra', 'edit')){
                                                    setIdToEdit(condition.id); 
                                                    setMessage(condition.description)
                                                }
                                            }}
                                            color={hasPermissionFunction('business-unit-extra', 'edit')?'info':'disabled'}
                                            style={{cursor:'pointer'}}
                                        />
                                        <DeleteIcon 
                                            color={hasPermissionFunction('business-unit-extra', 'edit') ?'error':'disabled'} 
                                            style={{cursor:'pointer'}}
                                            onClick={()=>{
                                                if(hasPermissionFunction('business-unit-extra', 'edit')){
                                                    setIdToDelete(condition.id); 
                                                    setOpenDeleteModal(true)
                                                }
                                            }}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
                </Table>
            </TableContainer>
        </ShowCard>
        <Grid container width={'100%'} justifyContent={'space-evenly'}>
            <EditInputsWrap lg={12}>
            <ShowCard
                title={translate('ra.title.files')}
                actionButtonJustify='flex-end'
                actionButtonDisabled={!hasPermissionFunction('business-unit-extra', 'edit')}
                actionButtonText={translate('ra.action.add_file')}
                actionButtonStyle={{ width: 'fit-content' }}
                onClickButton={()=>{
                    setOpenFileModal(true)
                    setType(2)
                }}
                
            >
                <TableContainer component={Paper} sx={{ marginY: '30px' }}>
                    <Table /* sx={{ minWidth: 650 }} */ aria-label='simple table'>
                    <TableHead>
                        <TableRow>
                        <TableCell >{translate('ra.field.message')}</TableCell>
                        <TableCell align='left'>{translate('ra.field.created_at')}</TableCell>
                        {/* <TableCell align='left'>{translate('ra.field.updated_at')}</TableCell> */}
                        <TableCell align='left'>{translate('ra.auth.username')}</TableCell>
                        <TableCell align='left'></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                             {
                                isFetchingData?
                                [...Array(3)].map((_, i) => (
                                    <TableRow key={i}>
                                        {[...Array(4)].map((_, i) => (<TableCell >
                                            <Skeleton variant='rectangular' width={'100%'} height={20} />
                                        </TableCell>))}
                                    </TableRow>
                                ))

                                :
                                filesData.map((condition, key)=>(
                                    <TableRow key={key}>
                                        <TableCell >{condition.description}</TableCell>
                                        <TableCell align='left'>
                                            {timeZoneFormat(condition.created_at, '00:00')}
                                        </TableCell>
                                        {/* <TableCell align='left'>
                                            {timeZoneFormat(condition.updated_at, '00:00')}
                                        </TableCell> */}
                                        <TableCell align='left'>{condition.user}</TableCell>
                                        <TableCell align='left'>
                                            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                                                <DownloadIcon
                                                    style={{cursor:'pointer'}}
                                                    color={'info'}
                                                    onClick={()=>{
                                                            saveFile(condition.file, condition.description)
                                                    }}
                                                />
                                                <DeleteIcon 
                                                    color={hasPermissionFunction('business-unit-extra', 'edit') ?'error':'disabled'} 
                                                    style={{cursor:'pointer'}}
                                                    onClick={()=>{
                                                        if(hasPermissionFunction('business-unit-extra', 'edit')){
                                                            setIdToDelete(condition.id); 
                                                            setOpenDeleteModal(true)
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                    </TableBody>
                    </Table>
                </TableContainer>
            </ShowCard>
            </EditInputsWrap>
            <EditInputsWrap lg={12}>
            <ShowCard
                title={'Links'}
                actionButtonJustify='flex-end'
                actionButtonDisabled={!hasPermissionFunction('business-unit-extra', 'edit')}
                actionButtonText={`${translate('ra.action.add')} link`}
                actionButtonStyle={{ width: 'fit-content' }}
                onClickButton={()=>{
                    setOpenCreateModal(true)
                    setType(3)
                }}
                
            >
                <TableContainer component={Paper} sx={{ marginY: '30px' }}>
                    <Table /* sx={{ minWidth: 650 }} */ aria-label='simple table'>
                    <TableHead>
                        <TableRow>
                        <TableCell >{translate('ra.field.message')}</TableCell>
                        <TableCell align='left'>{translate('ra.field.created_at')}</TableCell>
                        <TableCell align='left'>{translate('ra.field.updated_at')}</TableCell>
                        <TableCell align='left'>{translate('ra.auth.username')}</TableCell>
                        <TableCell align='left'></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                             {
                                isFetchingData?
                                [...Array(3)].map((_, i) => (
                                    <TableRow key={i}>
                                        {[...Array(4)].map((_, i) => (<TableCell >
                                            <Skeleton variant='rectangular' width={'100%'} height={20} />
                                        </TableCell>))}
                                    </TableRow>
                                ))

                                :
                                linksData.map((condition, key)=>(
                                    <TableRow key={key}>
                                        <TableCell>
                                            <a href={condition.description} target="_blank" rel="noopener noreferrer">
                                                {condition.description}
                                            </a>
                                        </TableCell>
                                        <TableCell align='left'>
                                            {timeZoneFormat(condition.created_at, '00:00')}
                                        </TableCell>
                                        <TableCell align='left'>
                                            {timeZoneFormat(condition.updated_at, '00:00')}
                                        </TableCell>
                                        <TableCell align='left'>{condition.user}</TableCell>
                                        <TableCell align='left'>
                                            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                                                <EditIcon 
                                                    onClick={()=>{
                                                        if(hasPermissionFunction('business-unit-extra', 'edit')){
                                                            setIdToEdit(condition.id); 
                                                            setMessage(condition.description)
                                                        }
                                                    }}
                                                    color={hasPermissionFunction('business-unit-extra', 'edit') ? 'info' :'disabled'} 
                                                    style={{cursor:'pointer'}}
                                                />
                                                <DeleteIcon 
                                                    color={hasPermissionFunction('business-unit-extra', 'edit') ? 'error':'disabled' }
                                                    style={{cursor:'pointer'}}
                                                    onClick={()=>{
                                                        if(hasPermissionFunction('business-unit-extra', 'edit')){
                                                            setIdToDelete(condition.id); 
                                                            setOpenDeleteModal(true)
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                    </TableBody>
                    </Table>
                </TableContainer>
            </ShowCard>
            </EditInputsWrap>
        </Grid>
        <Dialog fullWidth open={openFileModal} onClose={onCloseFile}>
            <DialogTitle>
                {translate('ra.action.add')}
            </DialogTitle>
            <DialogContent>
                <div className='inputFile' style={{marginBottom:'15px', width:'100%', padding:'15px'}}>

                    <label htmlFor="fileInput" style={{width:'100%', alignItems:'center', justifyContent:'center', display:'flex', cursor:'pointer' }}>
                        <input
                        type="file"
                        id="fileInput"
                        style={{ display: "none"}}
                        onChange={handleFileChange}
                    />
                    {selectedFile?.file?.name? selectedFile.file?.name : 'Seleccionar archivo'}
                    </label>
                    
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={onCloseFile}>
                    {translate('ra.action.cancel')}
                </Button>
                <LoadingButton 
                    variant='contained'
                    onClick={uploadFile}
                    disabled={!selectedFile}
                    loading={isLoadingCreate}
                >
                    {translate('ra.action.acept')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
        <Dialog fullWidth open={openCreateModal} onClose={onCloseModal}>
            <DialogTitle>
                {idToEdit ? translate('ra.action.edit') :translate('ra.action.add')}
            </DialogTitle>
            <DialogContent>
                <div style={{margin:'15px'}}>
                    <TextField
                        fullWidth
                        multiline
                        value={message}
                        label={translate('ra.field.message')}
                        onChange={val=>{
                            setMessage(val.target.value)
                        }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={onCloseModal}>
                    {translate('ra.action.cancel')}
                </Button>
                <LoadingButton 
                    variant='contained'
                    onClick={idToEdit ? updateCondition :createCondition}
                    loading={isLoadingCreate}
                    disabled={!message}
                >
                    {translate('ra.action.acept')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
        <ConfirmationDialog
            contentText={translate('ra.message.delete_condition_confirmation')}
            setOpen={setOpenDeleteModal}
            open={openDeleteModal}
            loadingMessage={loadingDelete}
            setConfirm={setConfirmDelete}
            buttonConfirmText={translate('ra.action.to_confirm')}
            buttonCancel={translate('ra.action.cancel')}
        />
    </>
  )

}
